import firebase from "firebase";
import {formatPrice} from "./formatHelper";
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import { MenuItemOption } from "../models";

export const evaluateItemPrice = (ditsMenuItem: DocumentSnapshot, qty: number = 1) => {
    const defaultPrice = ditsMenuItem?.data()?.price;
    return (defaultPrice) * qty;
}

export const evaluateItemPriceV2 = (menuItem: {[key:string]:any}, qty: number = 1) => {
    const defaultPrice = menuItem?.price;
    return (defaultPrice) * qty;
}

export const formatMenuItemPrice = (ditsMenuItem: DocumentSnapshot|null, qty: number = 1) => {
    if (!!ditsMenuItem) {
        return formatPrice(evaluateItemPrice(ditsMenuItem, qty));
    }
    return formatPrice(0);
}

export const formatMenuItemPriceV2 = (ditsMenuItem: {[key:string]:any}, qty: number = 1) => {
    if (!!ditsMenuItem) {
        return formatPrice(evaluateItemPriceV2(ditsMenuItem, qty));
    }
    return formatPrice(0);
}

export const getOptionId = (option: MenuItemOption):string => {
    return option.ref ?? option.id ?? option.name ?? option.title ?? "";
}
